import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyInputModule, SelectInputOptionInterface } from '@vendasta/galaxy/input';
import { of } from 'rxjs';
import { DynamicOptionsComponent } from '../dynamic-options';

@Component({
  selector: 'automata-is-empty-options',
  templateUrl: './is-empty-options.component.html',
  styleUrls: ['./is-empty-options.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyInputModule,
  ],
})
export class IsEmptyOptionsComponent implements OnInit, DynamicOptionsComponent {
  @Input() initialValue = false;

  isEmptyFormControl: UntypedFormControl = new UntypedFormControl('', Validators.required);
  isEmptyOptions: SelectInputOptionInterface[];

  selectedValue$ = of(null);

  constructor(private readonly translateService: TranslateService) {}

  ngOnInit(): void {
    this.isEmptyFormControl.setValue(this.initialValue);
    this.isEmptyOptions = [
      {
        label: this.translateService.instant(
          'AUTOMATIONS.EDITOR.FILTERS.SHOPPING_CART_CONTENTS.OPTION_LABELS.NOT_EMPTY',
        ),
        value: true,
      },
      {
        label: this.translateService.instant('AUTOMATIONS.EDITOR.FILTERS.SHOPPING_CART_CONTENTS.OPTION_LABELS.EMPTY'),
        value: false,
      },
    ];
    this.isEmptyOptions.forEach((option) => {
      option.selected = option.value === this.isEmptyFormControl.value;
    });
  }

  getSelectedValue(): boolean {
    return this.isEmptyFormControl.value;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.isEmptyFormControl];
  }

  isFormValid(): boolean {
    return this.isEmptyFormControl.valid;
  }
}
